export default function useRecordAdjustment(records: any, add: (data: any) => void, attr: string): [boolean, (data: any) => void] {
  const hasRecord = records && records.length > 0

  const addRecordAdjustment = (data: any): void => {
    const adjustment = {
      ...data,
      id: undefined,
      [attr]: -data[attr],
    }
    add(adjustment)
  }

  return [hasRecord, addRecordAdjustment]
}
